var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 193,
    viewBox: "0 0 256 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.5 1.00003H6.5C3.46243 1.00003 1 3.46246 1 6.50003V186.5C1 189.538 3.46243 192 6.5 192H249.5C252.538 192 255 189.538 255 186.5V6.50003C255 3.46246 252.538 1.00003 249.5 1.00003Z",
    stroke: "#718095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 42V99V99C73 101.209 74.7909 103 77 103H80.5H174H179C181.209 103 183 104.791 183 107V111V160.5V160.5C183 163.538 180.538 166 177.5 166H175.5L80 165.5H78.5C75.7386 165.5 73.5 167.739 73.5 170.5V170.5V177.5",
    stroke: "#718095",
    strokeOpacity: 0.45
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 42.5,
    width: 105,
    height: 58,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 47,
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 72.5,
    width: 54,
    height: 3,
    rx: 1.5,
    fill: "#4B5563"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 76.5,
    width: 83,
    height: 17,
    rx: 3,
    fill: "#718095"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 105.5,
    width: 105,
    height: 58,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 109.5,
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 135.5,
    width: 54,
    height: 3,
    rx: 1.5,
    fill: "#4B5563"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 140.5,
    width: 83,
    height: 17,
    rx: 3,
    fill: "#718095"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 15,
    width: 61,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 24,
    width: 110,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 27,
    width: 81,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.d975b3ead4af52ebd04c98f2f903f3d7.svg";
export { ForwardRef as ReactComponent };